var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 511,
    viewBox: "0 0 535 511",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.366 67.4634C336.749 88.1143 436.581 13.3181 495.819 71.41C556.254 130.677 532.812 234.012 508.921 315.135C485.687 394.025 446.57 482.047 367.824 506.015C293.906 528.514 230.135 456.713 161.683 420.825C115.847 396.794 68.6998 377.246 40.0563 334.171C9.33741 287.975 -0.636451 234.428 0.881288 179.006C3.03934 100.203 -5.99162 40.1063 66.3053 8.54194C140.505 -23.8533 177.912 47.3079 256.366 67.4634Z",
    fill: "#EAF3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundImage);
export default __webpack_public_path__ + "static/media/BackgroundImage.41e7553ff29029bf25de0fc185a8fcaa.svg";
export { ForwardRef as ReactComponent };